<template src="./operazioni.html"></template>

<script>
import { getOperazioni, get_listaClientiComuicazioni } from "@/api/api.dati.js";

export default {
    data: () => ({
        headerProps: {
            sortByText: "Ordina per",
        },
        page: 1,
        pageCount: 0,
        search: "",
        loadingTabella: false,
        menu1: false,

        operazioni: [],
        headersDati: [
            { text: "Nome risorsa", value: "nomeRisorsa", sortable: false },
            {
                text: "Indirizzo",
                value: "pathRisorsa",
                sortable: false,
            },
            { text: "Operazione", value: "descrizione", sortable: false },
            { text: "Data Operazione", value: "dataOperazione", sortable: false },
            { text: "Cliente", value: "nomeCliente", sortable: false },
        ],

        dataOperazione: "",

        clienti: [],
        clienteSel: {
            username: "",
        },
    }),

    methods: {
        async caricaDati() {
            this.loadingTabella = true;

            let par = {
                cliente: this.clienteSel.username,
                dataInizio: "",
                dataFine: "",
            }

            if (this.dataOperazione != "") {
                par.dataInizio = this.setDate(this.dataOperazione) + " " + "00:00:00";
                par.dataFine = this.setDate(this.dataOperazione) + " " + "23:59:59";
            }
            let res = await getOperazioni(par);
            this.operazioni = res.data;

            this.loadingTabella = false;
        },

        async caricaClienti() {
            // Reset
            this.clienti = [];
            this.clienteSel = {};

            this.loadingTabella = true;

            let par = {
                Cliente: false,
            }
            let res = await get_listaClientiComuicazioni(par);
            this.clienti = res.data;
            let cliente = {
                companyCode: "TUTTI",
                enabled: false,
                modificato: false,
                passwordHash: "",
                roleId: "",
                userId: -1,
                username: "TUTTI",
            }
            this.clienti.unshift(cliente);
            this.$store.commit("app/setListaClienti", this.clienti);
            this.clienteSel = this.clienti[0];

            this.loadingTabella = false;
        },

        async refresh() {
            await this.caricaClienti();
            this.resetCampi();
            await this.caricaDati();
        },

        resetCampi() {
            this.dataOperazione = "";
            this.search = "";
            this.clienteSel = this.clienti[0];
        },

        setDate(data) {
            let primaData = data.substring(0, 10);
            let [anno, mese, giorno] = primaData.split("-");
            let dataFormattata = `${giorno}/${mese}/${anno}`;
            return dataFormattata + " " + data.substring(11, 19);
        },
    },

    async mounted() {
        await this.caricaClienti();
        await this.caricaDati();
    },

    created() {
        if (this.role != "admin")
            this.$router.push({ path: "/" });
    },

    watch: {},

    computed: {
        GetLoading() {
            return this.$store.getters["app/getLoading"];
        },
        dataPrev1() {
            if (this.dataOperazione.length == 0) return "";

            const [year, month, day] = this.dataOperazione.split("-");
            return `${day.substring(0, 2)}/${month}/${year}`;
        },

        role() {
            return this.$store.getters['user/getRole'];
        },
    },
};
</script>